import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function HotBoard() {
  const ranked = [...topics].sort((a, b) => b.heat - a.heat);
  const featured = ranked[0];
  const rest = ranked.slice(1, 6);
  const maxHeat = ranked[0].heat;

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <span className="flex items-center gap-2 font-label text-xs font-medium tracking-[0.2em] text-primary-600">
              <i className="ri-fire-fill"></i>
              今日热榜
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              讨论量最高的几件事
            </h2>
          </div>
          <p className="font-label text-sm text-foreground-500">
            按讨论量 · 转发量 · 浏览量的综合热度排序
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <TopicCard topic={featured} featured />
          </div>

          <div className="lg:col-span-5">
            <ol className="flex h-full flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
              {rest.map((topic, index) => (
                <li key={topic.id} className="flex-1">
                  <Link
                    to={`/topic/${topic.id}`}
                    className="group flex h-full items-center gap-4 p-4 transition-colors hover:bg-primary-50"
                  >
                    <span
                      className={`flex h-8 w-8 flex-none items-center justify-center rounded-md font-heading text-sm font-bold ${
                        index === 0
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {index + 2}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block font-label text-[11px] text-primary-600">
                        {topic.category}
                      </span>
                      <span className="mt-0.5 block truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
                        {topic.title}
                      </span>
                      <span className="mt-2 block h-1 w-full overflow-hidden rounded-full bg-background-200">
                        <span
                          className="block h-full rounded-full bg-accent-500"
                          style={{ width: `${Math.round((topic.heat / maxHeat) * 100)}%` }}
                        ></span>
                      </span>
                    </span>
                    <span className="flex-none font-label text-xs text-foreground-500">
                      {topic.heat}
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}